// サジェスト機能で使用する「対象画面」のマスタ定義
export const PAGE_TYPE_MASTER = [
  { value: "requirements_definition_operations", label: "要件定義" },
  { value: "basic_design_operations", label: "基本設計" },
  { value: "detail_design_operations", label: "詳細設計" },
  { value: "program_operations", label: "製造/構築" },
  { value: "test_operations", label: "テスト" },
  { value: "maintenance_operations", label: "保守/運用" },
  { value: "frontend_languages", label: "フロントエンド" },
  { value: "backend_languages", label: "バックエンド" },
  { value: "business_systems", label: "業務システム" },
  { value: "cloud_services", label: "クラウド" },
  { value: "server_operating_systems", label: "サーバーOS" },
  { value: "operating_systems", label: "クライアントOS" },
  { value: "middlewares", label: "ミドルウェア" },
  { value: "dbs", label: "DB" },
  { value: "networks", label: "Network" },
  { value: "design_tools", label: "デザイン" },
  { value: "tools", label: "ツール" },
];

// サジェスト機能で使用する「優先度」マスタ
export const PRIORITY_MASTER = [
  { value: "high", label: "高" },
  { value: "medium", label: "中" },
  { value: "low", label: "低" },
];

// Stepper（activeStep）→ page_type（fieldName）変換用
// step0 は ProjectInfoForm（サジェスト無し）
export const STEP_PAGE_TYPE_MAP = [
  "", // 0
  ...PAGE_TYPE_MASTER.map((p) => p.value),
];
